import { FaqCategories } from './faq-data';

export const config = {
    search_query_key: 'filter',
    category_query_key: 'category',
    default_category: FaqCategories.Popular,
    minimal_search_length: 2,
} as const;
